import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { AngazovanjeRo } from './angazovanje-ro';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import value from '*.json';
import { AngazovanjeRoResenje } from './angazovanje-ro-resenje';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-angazovanje-ro-resenje-update',
  templateUrl: './angazovanje-ro-resenje-update.component.html'
})
export class AngazovanjeRoResenjeUpdateComponent
// extends BaseUpdateComponent<AngazovanjeRo> 
extends BaseUpdateComponent<AngazovanjeRoResenje> 
implements OnInit {

  // Ugovor=false;
  // RaskidUgovora=false;
  // AneksUgovora=false;
  editMode=false;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService

  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.IDProcessed
    .subscribe((value) => {
      if (this.Item.ID!=null){
        this.editMode=true;
      }
      if (!this.editMode){
        let osobaId=this.Parameters.find(x => x["Name"] =="OsobaID")["Value"]
        let tataId=this.Parameters.find(x => x["Name"] =="TataID")["Value"]
        this.baseFormGroup.patchValue({OsobaID: osobaId});
        this.baseFormGroup.patchValue({TataID: tataId});
        this.baseFormGroup.controls["OsobaID"].disable();
        this.baseFormGroup.controls["TataID"].disable();
      }
    })

  }

  onPodvrstaDokumentaStavkaSelected(item){
    if (item!=null){
      // this.RaskidUgovora=item["PodvrstaDokumentaGn"]=="resenje";
      // this.Ugovor=item["PodvrstaDokumentaGn"]=="ug";
      // this.AneksUgovora=item["PodvrstaDokumentaGn"]=="anex_ug";
      this.getBrojDokumenta();
    }
  }

  onDatumChange(value) {
    if (value != null) {
      this.getBrojDokumenta();
    }
  }

  getBrojDokumenta() {
    let podvrstaid = this.baseFormGroup.get('PodvrstaDokumentaStavkaID').value;
    let datum = this.baseFormGroup.get('Datum').value;
    if (this.Item.ID == -1 && podvrstaid && datum)
        this.baseDataService.GetData('AngazovanjeRo', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
            .subscribe(data => {
                this.baseFormGroup.patchValue({ Broj: data });
                this.baseFormGroup.get('Broj').updateValueAndValidity();
            })

  }

}